/** @file Plain snapshot of a draft value, or the value itself when it was assigned in this produce. */
import { current, isDraft, type Draft } from 'immer';

/**
 * immer's `current` for a draft; a value assigned earlier in the same produce (a plan's earlier command) is not a
 * draft, and `current` would throw on it, so it is returned as is. Read the result; never write into it.
 */
export function currentOf<T>(value: T): T {
  return isDraft(value) ? current<T>(value as Draft<T>) : value;
}
